// src/utils/parseTabular.js
//
// Abhaengigkeitsfreier CSV-Parser fuer den Team-Import.
//
// Bewusst KEINE Bibliothek (PapaParse o.ae.): das Projekt ersetzt kleine
// Fremd-Dependencies bereits an anderer Stelle durch Handgeschriebenes
// (helmet -> eigene Header). Der Funktionsumfang hier ist klein und klar
// umrissen: ein Google-Forms-Export ist eine flache CSV mit Kopfzeile.
//
// Kann:
//  - Trennzeichen automatisch erkennen (Komma, Semikolon, Tab) – Excel schreibt
//    im deutschen Gebietsschema Semikolon, Google Sheets Komma.
//  - In Anfuehrungszeichen gesetzte Felder inkl. eingebetteter Trennzeichen,
//    Zeilenumbrueche und verdoppelter Anfuehrungszeichen ("").
//  - BOM am Dateianfang entfernen (Excel/Sheets hängen ihn oft an).

/** Trennzeichen anhand der ersten (nicht in Quotes liegenden) Zeile schaetzen. */
function erkenneTrennzeichen(text) {
  const kandidaten = [",", ";", "\t"];
  // Nur die erste Zeile betrachten – dort steht die Kopfzeile ohne Quotes-Umbrueche.
  const ersteZeile = text.split(/\r?\n/, 1)[0] || "";
  let bestes = ",";
  let maxAnzahl = -1;
  for (const d of kandidaten) {
    const anzahl = ersteZeile.split(d).length - 1;
    if (anzahl > maxAnzahl) {
      maxAnzahl = anzahl;
      bestes = d;
    }
  }
  return bestes;
}

/**
 * CSV-Text in ein Array von Zeilen-Arrays zerlegen (Zustandsautomat).
 * Behandelt Quotes, verdoppelte Quotes und Zeilenumbrueche innerhalb von Quotes.
 */
function zerlege(text, trenner) {
  const zeilen = [];
  let feld = "";
  let zeile = [];
  let inQuotes = false;

  for (let i = 0; i < text.length; i++) {
    const c = text[i];

    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') { feld += '"'; i++; } // verdoppeltes Quote
        else inQuotes = false;
      } else {
        feld += c;
      }
      continue;
    }

    if (c === '"') { inQuotes = true; continue; }
    if (c === trenner) { zeile.push(feld); feld = ""; continue; }
    if (c === "\n") { zeile.push(feld); zeilen.push(zeile); feld = ""; zeile = []; continue; }
    if (c === "\r") { continue; } // \r\n und alleinstehendes \r ignorieren
    feld += c;
  }

  // letztes Feld/Zeile nachziehen, falls die Datei ohne Zeilenumbruch endet
  if (feld.length > 0 || zeile.length > 0) {
    zeile.push(feld);
    zeilen.push(zeile);
  }

  return zeilen;
}

/**
 * CSV-Text parsen.
 * @returns {{ headers: string[], rows: Object[] }}
 *   `headers` = getrimmte Spaltenkoepfe der ersten Zeile.
 *   `rows`    = je Datenzeile ein Objekt { header -> Zellwert }.
 * Vollstaendig leere Zeilen werden verworfen (Google haengt oft eine an).
 */
export function parseCSV(text) {
  if (typeof text !== "string" || !text.trim()) return { headers: [], rows: [] };

  // BOM entfernen
  if (text.charCodeAt(0) === 0xfeff) text = text.slice(1);

  const trenner = erkenneTrennzeichen(text);
  const matrix = zerlege(text, trenner);
  if (matrix.length === 0) return { headers: [], rows: [] };

  const headers = matrix[0].map((h) => (h || "").trim());

  const rows = [];
  for (let r = 1; r < matrix.length; r++) {
    const werte = matrix[r];
    const leer = werte.every((v) => (v || "").trim() === "");
    if (leer) continue;

    const obj = {};
    headers.forEach((h, i) => { obj[h] = werte[i] !== undefined ? werte[i] : ""; });
    rows.push(obj);
  }

  return { headers, rows };
}

/** Datei als UTF-8-Text einlesen (Promise). */
export function leseDateiAlsText(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(reader.error || new Error("Datei konnte nicht gelesen werden"));
    reader.readAsText(file, "UTF-8");
  });
}
